import { render, staticRenderFns } from "./ThgPortal.vue?vue&type=template&id=f7935eca&"
import script from "./ThgPortal.vue?vue&type=script&lang=ts&"
export * from "./ThgPortal.vue?vue&type=script&lang=ts&"
import style1 from "./ThgPortal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports